// Module Federation 💩

export function singleton<T>(key: string, value: T): T {
  const store = (typeof window !== "undefined" ? window : global) as unknown as Record<string, T>;

  store[key] ??= value;
  return store[key];
}
